import axios from 'axios';
import { useStorage } from '../hooks/use-storage';

function useItemAPI() {
  const { languageRef } = useStorage();

  function loadItemFromRemote(id) {
    const url = `/vbeta2/menu/items/${id}`;

    return axios({
      url,
      method: 'get',
      params: {
        lang: languageRef.current?.tag,
      },
      headers: {
        'Accept-Language': languageRef.current?.tag,
      },
      responseType: 'json',
    });
  }

  return {
    loadItemFromRemote,
  };
}

export { useItemAPI };
